import type { ComponentType } from 'react';
import type { LucideIcon } from 'lucide-react';
import type { InteractionRecord } from '@/shared/analytics/AnalyticsTypes';

export interface RecordDrawerSectionProps {
    record: InteractionRecord;
}

export interface RecordDrawerExtension {
    /** Tab label in the record drawer (e.g. "Governance"). */
    label: string;
    /** Tab icon (e.g. the governance shield). */
    icon?: LucideIcon;
    component: ComponentType<RecordDrawerSectionProps>;
}

const extensions: RecordDrawerExtension[] = [];

/**
 * Registers a feature-contributed tab appended to the interaction record
 * drawer (e.g. governance policy verdicts). Called from the composition root so
 * the drawer under src/shared stays feature-blind.
 */
export function registerRecordDrawerSection(extension: RecordDrawerExtension): void {
    if (!extensions.some((entry) => entry.label === extension.label)) extensions.push(extension);
}

/** The registered drawer tabs, in registration order. */
export function recordDrawerExtensions(): readonly RecordDrawerExtension[] {
    return extensions;
}
